"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var _require = require("./html-utils.js"),
  getHtmlContent = _require.getHtmlContent;
module.exports = function handleImage(type, element, runProperties, transformer) {
  if (!transformer.img) {
    if (transformer.ignoreUnknownTags) {
      return "";
    }
    var error = new Error("Tag ".concat(type, " is not supported if imagemodule not included (See https://docxtemplater.com/modules/html/#supportforimageswithimg)"));
    throw error;
  }
  var htmlContent = getHtmlContent(element);
  if (type !== "svg" && !element.attribs.src) {
    if (element.centered) {
      return "";
    }
    return "<w:r><w:t></w:t></w:r>";
  }
  transformer.img.dpi = transformer.dpi;
  var _transformer$part = transformer.part,
    lIndex = _transformer$part.lIndex,
    containerWidth = _transformer$part.containerWidth,
    containerHeight = _transformer$part.containerHeight,
    pageHeight = _transformer$part.pageHeight,
    pageWidth = _transformer$part.pageWidth,
    section = _transformer$part.section;
  element.lIndex || (element.lIndex = lIndex);
  var _transformer$img$rend = transformer.img.render({
      type: "placeholder",
      module: element.centered ? "open-xml-templating/docxtemplater-image-module-centered" : "open-xml-templating/docxtemplater-image-module",
      value: {
        element: element,
        part: transformer.part,
        transformer: transformer,
        htmlContent: htmlContent
      },
      lIndex: element.lIndex,
      containerWidth: containerWidth,
      containerHeight: containerHeight,
      pageHeight: pageHeight,
      pageWidth: pageWidth,
      section: section
    }, _objectSpread(_objectSpread({}, transformer.renderOptions), {}, {
      resolvedId: element.lIndex + transformer.renderOptions.scopeManager.scopePathItem.join("-"),
      scopeManager: _objectSpread(_objectSpread({}, transformer.renderOptions.scopeManager), {}, {
        getValue: function getValue(src) {
          return src;
        },
        getValueAsync: function getValueAsync(src) {
          return Promise.resolve(src);
        }
      })
    })),
    value = _transformer$img$rend.value,
    errors = _transformer$img$rend.errors;
  if (errors && errors.length > 0) {
    transformer.collectErrors(errors);
  }
  if (element.centered) {
    return value;
  }
  if (!value) {
    return "";
  }
  return "<w:r>\n\t\t<w:rPr/>\n\t\t".concat(value, "\n\t\t</w:r>\n\t\t");
};